import {isTVOS} from 'common/constants';

export const tvScreenConstants = {
  channelKeyThrottle: 200,
  tuneDelay: isTVOS ? 500 : 1000
};
